import React from "react";
import { Formik, Field, Form } from "formik";
import { Form as SemForm, Message } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import "../login.css";

const validate = (values) => {
	let errors = {};
	if (!values.login) {
		errors.login = "Champ requis";
	} /* else if (values.login.includes("@") && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.login)) {
		errors.login = "Adresse e-mail invalide";
	}
	if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*.-]).{3,}$/i.test(values.password)) {
		errors.password = <><p>Le mot de passe doit contenir Minimum 3 caractères, au moins une lettre majuscule,</p>
						  <p> une lettre minuscule, un chiffre et un caractère spécial. exemple : Abcdefg2.0 </p></>; 
	} */
	return errors;
};

const CustomInputTextComponent = ({ field, form: { touched, errors }, ...props }) => (
	<div>
		<SemForm.Input
			{...field}
			{...props}
			fluid
			icon="user"
			iconPosition="left"
			placeholder="Adresse email ou identifiant"
			style={{ marginBottom: 10 }}
		/>
		{touched[field.name] && errors[field.name] && <Message error>{errors[field.name]}</Message>}
	</div>
);

const CustomInputPasswordComponent = ({ field, form: { touched, errors }, ...props }) => (
	<div>
		<SemForm.Input {...field} {...props} fluid icon="lock" iconPosition="left" placeholder="Password" type="password" style={{ marginBottom: 10 }} />
		{touched[field.name] && errors[field.name] && <Message error>{errors[field.name]}</Message>}
	</div>
);

const Basic = ({ submitAuth }) => (
	<div>
		<Formik initialValues={{ login: "", password: "" }} validate={(values) => validate(values)} onSubmit={(values) => submitAuth(values)}>
			{() => (
				<Form className="loginForm">
					<Field type="text" name="login" component={CustomInputTextComponent} className="login__input" />
					<Field className="login__input" type="password" name="password" autocomplete="off" component={CustomInputPasswordComponent} />
					<MainButton text="Se connecter" type="submit" style={{ width: "100%" }} />
				</Form>
			)}
		</Formik>
	</div>
);

export default Basic;
